import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { SharedModule } from '../../shared/shared.module';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { CustomSearchBarComponent } from '../../shared/components/custom-search-bar/custom-search-bar.component';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import {
  NavigationItem,
  navigationItemsNoPatient,
} from '../../models/navigation-item-model';
import { pages, classes } from '../../shared/labels';
import { AiService } from '../../services/ai.service';
import { ActivePatientFieldsForAiAnalysis } from '../../models/patient-model';
import { ErrorPanelService } from '../../services/error-panel.service';
import {
  AiFeature,
  aiFeatureGroups,
  aiFeatures,
} from '../../models/descriptions/ai-descriptions';

interface PatientList {
  id: string;
  first_name: string;
  last_name: string;
}

@Component({
  selector: 'app-ai-analysis-page',
  standalone: true,
  templateUrl: './ai-analysis-page.component.html',
  styleUrls: ['./ai-analysis-page.component.scss'],
  imports: [
    SharedModule,
    MatCardModule,
    MatTableModule,
    MatPaginatorModule,
    CustomSearchBarComponent,
    MatButtonModule,
    MatIconModule,
  ],
  animations: [
    trigger('fadeInOut', [
      state(
        'void',
        style({
          opacity: 0,
          transform: 'translateY(-10px)',
        })
      ),
      state(
        '*',
        style({
          opacity: 1,
          transform: 'translateY(0)',
        })
      ),
      transition('void <=> *', animate('300ms ease-in-out')),
    ]),
  ],
})
export class AiAnalysisPageComponent implements OnInit {
  patients: PatientList[] = [];
  displayedColumns: string[] = ['name'];
  patientListDataSource: MatTableDataSource<PatientList>;
  navigationItems: NavigationItem[];
  selectedFeature: string | null = null;
  readonly aiFeatureGroups = aiFeatureGroups;
  isLoading: boolean = true;

  isMobile: boolean = window.innerWidth < 930;

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private aiService: AiService,
    private router: Router,
    private errorPanelService: ErrorPanelService
  ) {
    this.patientListDataSource = new MatTableDataSource<PatientList>([]);
    this.navigationItems = navigationItemsNoPatient.map((item) => {
      if (item.label === pages.aiAnalyses) {
        return { ...item, class: classes.hb };
      }
      return { ...item };
    });
  }

  ngOnInit() {
    this.getPatients();
  }

  ngAfterViewInit() {
    this.patientListDataSource.paginator = this.paginator;
  }

  getPatients() {
    this.isLoading = true;
    this.aiService.getActivePatientsFieldsForAiAnalysis().subscribe({
      next: (patients: ActivePatientFieldsForAiAnalysis[]) => {
        this.patients = patients.sort((a, b) =>
          a.last_name.localeCompare(b.last_name)
        );
        this.patientListDataSource.data = this.patients;
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error fetching patients:', error);
        this.isLoading = false;
        this.errorPanelService.showErrorSnackBar(
          'Errore durante il recupero dei pazienti'
        );
        // Handle error (e.g., show error message to user)
      },
    });
  }

  filterPatients(searchTerm: string) {
    this.patientListDataSource.filter = searchTerm.trim().toLowerCase();
  }

  navigateToPatientAnalysis(patient: PatientList) {
    this.router.navigate(['/analisi-ai', patient.id]);
  }

  toggleFeatureDescription(feature: string) {
    if (this.selectedFeature === feature) {
      this.selectedFeature = null;
    } else {
      this.selectedFeature = feature;
    }
  }

  get activeFeature(): AiFeature | undefined {
    return aiFeatures.find((feature) => feature.id === this.selectedFeature);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isMobile = window.innerWidth < 930;
  }
}
